export default defineNuxtPlugin(async (nuxtApp) => {

  const rootStore = useRootStore();
  const { EcomService } = await import("~/services/ecom.service");

  // TODO: improve mechanism to not use hardcoded value
  // need a rootStore initializer to store expires_in ecom response
  const accessTokenData = useCookie("ecomApiAccessToken");

  if(!accessTokenData.value || !accessTokenData.value.accessToken || !accessTokenData.value.expiresTime
      || !EcomService.isTokenValid(accessTokenData.value.accessToken,
          accessTokenData.value.expiresTime,EcomService.accessTokenExpiryBuffer)){
    await EcomService.refreshToken();
  }

  // 3599 - 300 : Since we do not want for the access_token to fully expire
  const interval_time =
      EcomService.accessTokenPollInterval *
      1000;

    rootStore.access_token_interval_id = setInterval(async () => {

      try {
        const accessTokenData = useCookie("ecomApiAccessToken");

        if(!accessTokenData.value || !accessTokenData.value.accessToken || !accessTokenData.value.expiresTime
            || !EcomService.isTokenValid(accessTokenData.value.accessToken,
                accessTokenData.value.expiresTime,EcomService.accessTokenExpiryBuffer)){
            await EcomService.refreshToken();
        }
      } catch (error) {
        console.error("Failed to refresh token:", error);
      }
    }, interval_time);


});
